const DEFAULT_REVOKE_DELAY_MS = 60000;

/**
 * Opens a Blob in a new browser tab via a temporary object URL, revoking it after
 * a delay long enough for the new tab to finish loading the content.
 */
export function openBlobInNewTab(blob: Blob, revokeDelayMs: number = DEFAULT_REVOKE_DELAY_MS): void {
  const objectUrl = window.URL.createObjectURL(blob);
  window.open(objectUrl, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(objectUrl), revokeDelayMs);
}

/**
 * Triggers a browser file download for a Blob via a temporary anchor element,
 * then synchronously revokes the object URL (safe once download has started,
 * unlike the new-tab case above which needs the tab time to load first).
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
